/* global FormData */
import { Row, Col, Form, FormGroup, Label, Input } from 'reactstrap'
import { gql, useQuery, useMutation } from '@apollo/client'
import { Fragment, useState } from 'react'
import classnames from 'classnames'
import { toast } from 'react-toastify'
import { Pendientes } from './index'

const mutation = gql`
    mutation create($hoja: String!, $tarea: ID!, $observaciones: String) {
        createBitacoraGeneral(hoja: $hoja, tarea: $tarea, observaciones: $observaciones)
    }
`

export default function Ingreso () {
  const query = gql`
  query Bitacora {
    categoriaGenerales {
      nombre
      tareas {
        nombre
      }
    }
  }
`
  const { data } = useQuery(query)
  const [send, { loading }] = useMutation(mutation)
  const [cat, setCat] = useState('Mantenimiento Preventivo')

  function handleSubmit (event) {
    event.preventDefault()
    const variables = Object.fromEntries(new FormData(event.target))

    send({ variables })
      .then(() => toast.success('Bitacora agregada!'))
      .catch(err => {
        console.log(err)
        toast.error('Error al guardar bitacora')
      })
  }

  const tareas = data
    ? data.categoriaGenerales.find(c => c.nombre === cat).tareas
    : []

  return (
    <>
      <h2 className='text-center mb-4'>Ingreso Mantenimiento Preventivo</h2>
      <Row>
        <Col>
          <Form onSubmit={handleSubmit}>
            <Row form>
              <Col className='pr-3'>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for='cat'>Categoria</Label>
                      <Input type='select' name='cat' onChange={ev => setCat(ev.target.value)}>
                        <option value='Mantenimiento Preventivo'>Mantenimiento Preventivo</option>
                        <option value='Mantenimiento Correctivo'>Mantenimiento Correctivo</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for='tarea'>Tarea</Label>
                      <Input type='select' name='tarea'>
                        {tareas.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label for='hoja'>Hoja de bitacora</Label>
                      <Input type='text' name='hoja' required />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <Col className='pl-3'>
                <FormGroup>
                  <Label for='observaciones'>Observaciones</Label>
                  <Input type='textarea' name='observaciones' />
                </FormGroup>
              </Col>
            </Row>

            <button type='submit' className={classnames('btn btn-primary', { disabled: loading })}>{loading ? 'Enviando..' : 'Enviar'}</button>
          </Form>
        </Col>
      </Row>
      <Row className='mt-5 flex-grow-1'>
        <Col>
          <Row>
            <Col>
              Tareas Pendientes:
            </Col>
          </Row>
          <Pendientes pendientes />
        </Col>
      </Row>
    </>
  )
}
